<template>
  <div class="position-relative dinA4">
    <img :src="require('@/assets/insular-header.png')" class="mb-6 page__header" />
    <div class="page__container">
      <div class="d-flex mb-12">
        <img class="img-contain product-icon" :src="require('@/assets/cttcanarias-icon.png')" />
        <div class="d-flex flex-column ml-6">
          <p class="red-title red-title--bold mb-2">
            Servicio de entrega para envíos a Canarias
          </p>
          <p class="body-1 justify-text">
            <b>Cobertura insular:</b> Servicio de entrega prevista en 14h, 24h y marítimo desde
            el siguiente día laborable al de su recogida.
          </p>
        </div>
      </div>

      <div class="d-flex mb-12">
        <img class="img-contain product-icon" :src="require('@/assets/cttbaleares-icon.png')" />
        <div class="d-flex flex-column ml-6">
          <p class="red-title red-title--bold mb-2">
            Servicio de entrega para envíos a Baleares
          </p>
          <p class="body-1 justify-text">
            <b>Cobertura insular:</b> Servicio de entrega prevista en 14h, 24h y 48h desde el
            siguiente día laborable al de su recogida.
          </p>
        </div>
      </div>
      <div class="d-flex mb-12">
        <img class="img-contain product-icon" :src="require('@/assets/cttotherdest-icon.png')" />
        <div class="d-flex flex-column ml-6">
          <p class="red-title red-title--bold mb-2">
            Servicio de entrega para envíos a Ceuta, Melilla, Andorra, ...
          </p>
          <p class="body-1 justify-text">
            <b>Cobertura otros destinos:</b> Servicio de entrega prevista en 24h y 48h desde el
            siguiente día laborable al de su recogida
          </p>
        </div>
      </div>
    </div>

    <Footer logo :page="previousPages + 1" />
  </div>
</template>

<script>
import Footer from '@/containers/offer-form/sign-off/pdf-venta-directa-2021/Footer'

export default {
  name: 'InsularIntro',
  components: { Footer },
  data() {
    return {
      previousPages: 0,
    }
  },
  mounted() {
    this.previousPages = this.$parent.sectionPreviousPages('InsularIntro')
  },
}
</script>
